﻿import FiconHover from "./FiconHover"; 
import FiconLightbox from "./FiconLightbox"; 

export default class FiconFactory {

	constructor(options) {

		this.event = "click";

		switch (options.mode) {
			case "lightbox":
				this.FiconClass = FiconLightbox;
				break;

			case "hover":
				this.FiconClass = FiconHover;

				if (options.invokeType === "hover") {
					this.event += " mouseenter";
				}

				break;

			default:
				throw `Unknown Ficons 'mode' value: ${options.mode}`;
		}

		this.FiconClass.init(options);
	}

	create($icon, options, event) {
		return new this.FiconClass($icon, options, event);
	}
}
